export default __webpack_public_path__ + "static/media/vertigo-horizontal-video.05c3ce4b.mp4";